export const USER_DATA_KEY = 'user';
export const SEARCH_USER_DATA_KEY = '@pwa:search-user-data';
